module.exports = __webpack_public_path__ + "static/typewriter4-7dfe4a817021a1cbf6293f8df2ec102b.png";